export const iconFontAwesomeGendersMarsStrokeUp = (
	<i className="fa-solid fa-mars-stroke-up"></i>
);
